import { create } from 'zustand';

const KEY = 'th.recentGames';
export const RECENT_LIMIT = 8;

type ByUser = Record<string, string[]>;

function load(): ByUser {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as unknown;
      if (parsed && typeof parsed === 'object') return parsed as ByUser;
    }
  } catch {
    /* ignore */
  }
  return {};
}

function save(v: ByUser): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(v));
  } catch {
    /* ignore */
  }
}

/** Order games were last opened on this device, most recent first, kept per account. */
export const useRecentGames = create<{ byUser: ByUser; record(userId: string, gameType: string): void }>((set, get) => ({
  byUser: load(),
  record(userId, gameType) {
    const cur = get().byUser[userId] ?? [];
    const next = [gameType, ...cur.filter((g) => g !== gameType)].slice(0, RECENT_LIMIT);
    const byUser = { ...get().byUser, [userId]: next };
    save(byUser);
    set({ byUser });
  },
}));

/** Combines what this device remembers with the games from the player's recent matches, newest first, no repeats. */
export function mergeRecent(local: readonly string[], fromServer: readonly string[], limit = 6): string[] {
  return [...new Set([...local, ...fromServer])].slice(0, limit);
}
